import { toRem, toRems } from 'helpers/theme'

/* eslint-disable quote-props */
const style = ({ theme }) => ({
    '& .categoriesList': {
        listStyle: 'none',
        padding: 0,
        margin: 0,
        display: 'flex',
        flexWrap: 'wrap',

        li: {
            marginBottom: toRem(10),
            marginRight: toRem(10),

            '&:last-of-type': {
                marginRight: 0
            }
        },

        a: {
            borderRadius: '100px',
            border: `2px solid ${theme.colors.goldDark}`,
            color: theme.colors.goldDark,
            padding: toRems([5, 20]),
            display: 'inline-block',

            '&.active': {
                background: theme.colors.goldDark,
                color: theme.colors.black
            }
        }
    }
})

export default style
